export default (event, attributes = {}) => {
  window.heap.track(event, attributes)
}
